<modal
    [modalId]="'lookup-form'"
    [modalSize]="'sm'"
    [windowClass]="windowClass"
    (close)="modalCleanup()">
    <div class="modal-inner" modal-inner>
            <mat-list class="mat-elevation-z8 lookup-list lookup-modal-item">
                <div *ngFor="let lookup of data;" class="lookup-item">
                    <mat-list-item [value]="lookup.id">{{lookup.name}}
                    </mat-list-item>
                    <button mat-icon-button (click)="delete(lookup)">
                        <i class="fas fa-lg fa-times"></i>
                    </button>
                </div>
            </mat-list>
            <mat-paginator class="lookup-paginator lookup-modal-item" [length]="resultsLength" [pageSize]="initialPageSize"
                           [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
        <div class="add-lookup-container lookup-modal-item">
            <div class="add-lookup">
                <mat-form-field class="custom-form-field">
                    <mat-label>New {{lookupName}}</mat-label>
                    <input matInput type="text" [(ngModel)]="newValue">
                </mat-form-field>
                <button mat-flat-button color="accent" (click)="addNew()" >
                    Add
                </button>
            </div>
        </div>
    </div>
</modal>
